import React, { useState, ReactNode, ElementType } from 'react';

type HoverTrackerProps<T extends ElementType> = {
    as?: T;
    children: (hovered: boolean) => ReactNode;
} & Omit<React.ComponentPropsWithoutRef<T>, 'children' | 'as' | 'onMouseEnter' | 'onMouseLeave'>;

export function HoverTracker<T extends ElementType = 'div'>({ as, children, ...rest }: HoverTrackerProps<T>) {
    const [hovered, setHovered] = useState(false);
    const Component = as || 'div';

    return (
        <Component onMouseEnter={() => setHovered(true)} onMouseLeave={() => setHovered(false)} {...rest}>
            {children(hovered)}
        </Component>
    );
}
